const getDisplayTitle = (fhirJson) => {
    if (fhirJson) {
        if (fhirJson.title && fhirJson.title.trim()) {
            return fhirJson.title.trim();
        }
        if (fhirJson.name) {
            if (typeof fhirJson.name === "string") {
                if (fhirJson.name.trim()) {
                    return fhirJson.name.trim();
                }
            } else if (Array.isArray(fhirJson.name) && fhirJson.name[0]?.text && fhirJson.name[0].text.trim()) {
                return fhirJson.name[0].text.trim();
            }
        }
    }
    return "[Untitled.]";
}

const generateCitationSummaryFromFhirJson = (fhirJson) => {
    if (!fhirJson) {
        return "";
    }

    let resourceType = fhirJson.resourceType || "Unidentified";
    if (resourceType === 'Project' || resourceType === 'SoftwareScript' || resourceType === 'ArtifactComment' ||
        resourceType === 'Characteristic' || resourceType === 'CommonDataStructure' || resourceType === 'CommonDatStructureArtifact' ||
        resourceType === 'EBMDecisionRating' || resourceType === 'EBMRecommendation' || resourceType === 'EvidenceReport' ||
        resourceType === 'Recommendation' || resourceType === 'SchemaElement' || resourceType === "Unidentified") {
        return "This Resource of type " + resourceType + "is not a proper FHIR Resource. If you see this message, contact support@computablepublishing.com";
    }

    let citedArtifactUrl = fhirJson.url || "TBD";
    if (citedArtifactUrl === "TBD" && fhirJson.extension?.length) {
        for (let extension of fhirJson.extension) {
            if (extension.url === "http://hl7.org/fhir/StructureDefinition/artifact-url" && extension.valueUri) {
                citedArtifactUrl = extension.valueUri;
                break;
            }
        }
    }
    let computableArtifactUrl = citedArtifactUrl + "#json";
    let articleDate = "";
    let lastRevisionDate = "";
    if (fhirJson.approvalDate) {
        articleDate = fhirJson.approvalDate;
    }
    if (fhirJson.date) {
        lastRevisionDate = fhirJson.date.slice(0, 10);
    } else if (fhirJson.meta?.lastUpdated) {
        lastRevisionDate = fhirJson.meta.lastUpdated.slice(0, 10);
    }
    let citedFOI = fhirJson.id || "TBD";
    let citationSummaryTitle = getDisplayTitle(fhirJson) || "[Untitled.]";

    let contributorshipSummary = "";

    let extensionTitle = "";
    let extensionName = "";
    let extensionAuthor = [];
    let extensionReviewer = [];
    let extensionEditor = [];
    let extensionEndorser = [];
    let extensionRecorder = [];

    if (Array.isArray(fhirJson.extension) && fhirJson.extension.length > 0) {
        for (const extension of fhirJson.extension) {
            switch (extension.url) {
                case 'http://hl7.org/fhir/StructureDefinition/artifact-title':
                    extensionTitle = extension.valueString;
                    break;
                case 'http://hl7.org/fhir/StructureDefinition/artifact-name':
                    extensionName = extension.valueString;
                    break;
                case 'http://hl7.org/fhir/StructureDefinition/artifact-url':
                    citedArtifactUrl = extension.valueUri;
                    break;
                case 'http://hl7.org/fhir/StructureDefinition/artifact-date':
                    lastRevisionDate = extension.valueDateTime.slice(0, 10);
                    break;
                case 'http://hl7.org/fhir/StructureDefinition/artifact-author':
                    extensionAuthor.push(extension.valueContactDetail.name);
                    break;
                case 'http://hl7.org/fhir/StructureDefinition/artifact-reviewer':
                    extensionReviewer.push(extension.valueContactDetail.name);
                    break;
                case 'http://hl7.org/fhir/StructureDefinition/artifact-editor':
                    extensionEditor.push(extension.valueContactDetail.name);
                    break;
                case 'http://hl7.org/fhir/StructureDefinition/artifact-endorser':
                    extensionEndorser.push(extension.valueContactDetail.name);
                    break;
                case 'http://hl7.org/fhir/StructureDefinition/artifact-recorder':
                    extensionRecorder.push(extension.valueContactDetail.name);
                    break;
                default:
                //
            }
        }
    }

    if (fhirJson.author) {
        if (typeof fhirJson.author === "object" && !Array.isArray(fhirJson.author)) {
            fhirJson.author = [fhirJson.author];
        }
        let authorNameList = fhirJson.author.map((author, authorIndex) => { return author.name || author.display }).join(', ');
        contributorshipSummary += authorNameList + " [Authors/Creators]. ";
    }
    if (extensionAuthor.length > 0) {
        contributorshipSummary += extensionAuthor.join(', ') + " [Authors/Creators]. ";
    }
    if (fhirJson.reviewer) {
        let reviewerNameList = fhirJson.reviewer.map((reviewer, reviewerIndex) => { return reviewer.name }).join(', ');
        contributorshipSummary += reviewerNameList + " [Reviewers]. ";
    }
    if (extensionReviewer.length > 0) {
        contributorshipSummary += extensionReviewer.join(', ') + " [Reviewers]. ";
    }
    if (fhirJson.editor) {
        let editorNameList = fhirJson.editor.map((editor, editorIndex) => { return editor.name }).join(', ');
        contributorshipSummary += editorNameList + " [Editors]. ";
    }
    if (extensionEditor.length > 0) {
        contributorshipSummary += extensionEditor.join(', ') + " [Editors]. ";
    }
    if (fhirJson.endorser) {
        let endorserNameList = fhirJson.endorser.map((endorser, endorserIndex) => { return endorser.name }).join(', ');
        contributorshipSummary += endorserNameList + " [Endorsers]. ";
    }
    if (extensionEndorser.length > 0) {
        contributorshipSummary += extensionEndorser.join(', ') + " [Endorsers]. ";
    }
    if (fhirJson.recorder) {
        let recorderNameList = fhirJson.recorder.map((recorder, recorderIndex) => { return recorder.name }).join(', ');
        contributorshipSummary += recorderNameList + " [Recorders]. ";
    }
    if (extensionRecorder.length > 0) {
        contributorshipSummary += extensionRecorder.join(', ') + " [Recorders]. ";
    }
    if (citationSummaryTitle === "UNTITLED RESOURCE" || citationSummaryTitle === "[Untitled.]") {
        citationSummaryTitle = extensionTitle || extensionName || "[Untitled.]";
    }

    let citationSummary = citationSummaryTitle +
        ' [Database Entry: FHIR ' + resourceType + ' Resource]. Contributors: ' +
        contributorshipSummary +
        "In: Fast Evidence Interoperability Resources (FEvIR) Platform, FOI " + citedFOI + ".";

    if (articleDate) {
        citationSummary += " Published " + articleDate + ".";
    }
    if (lastRevisionDate) {
        citationSummary += " Revised " + lastRevisionDate + ".";

    }
    if (citedArtifactUrl) {
        citationSummary += " Available at: " + citedArtifactUrl + ". Computable resource at: " + computableArtifactUrl + ".";
    }

    return citationSummary;
};

const addCitationSummaryToFhirJson = (fhirJson) => {

    let citationSummary = generateCitationSummaryFromFhirJson(fhirJson);
    if (!fhirJson) {
        return;
    }

    let resourceType = fhirJson.resourceType;
    if (resourceType === 'EvidenceVariable' || resourceType === 'Evidence' ||
        resourceType === 'ArtifactAssessment' || resourceType === 'ResearchStudy') {
        fhirJson.citeAs = citationSummary;
        if (fhirJson.citeAsMarkdown) {
            delete fhirJson.citeAsMarkdown;
        }
        if (fhirJson.citeAsReference) {
            delete fhirJson.citeAsReference;
        }
        if (Array.isArray(fhirJson.relatedArtifact) && fhirJson.relatedArtifact.length) {
            fhirJson.relatedArtifact = fhirJson.relatedArtifact.filter(item => item.type !== "cite-as");
        }
        if (fhirJson.relatedArtifact) {
            if (!fhirJson.relatesTo) {
                fhirJson.relatesTo = fhirJson.relatedArtifact.filter(item => item.type !== "cite-as");
            }
            delete fhirJson.relatedArtifact;
        }
    } else if (resourceType === 'Composition') {
        let relatesToCiteAs = {
            "type": {
                "coding": [{
                    "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
                    "code": "cite-as",
                    "display": "Cite As"
                }]
            },
            "targetMarkdown": citationSummary
        };
        let citeAsFound = false;
        let newRelatesToList = [];
        if (Array.isArray(fhirJson.relatesTo) && fhirJson.relatesTo.length > 0) {
            console.log("is array")
            newRelatesToList = fhirJson.relatesTo.map((relatedArtifactEntry) => {
                if (relatedArtifactEntry.type === "cite-as") {
                    citeAsFound = true;
                    return relatesToCiteAs;
                } else if (relatedArtifactEntry.type?.coding?.[0]?.code === "cite-as") {
                    citeAsFound = true;
                    return relatesToCiteAs;
                } else {
                    return relatedArtifactEntry;
                }
            })
        }
        console.log(citeAsFound)
        if (citeAsFound === false) {
            newRelatesToList.push(relatesToCiteAs);
        }
        fhirJson.relatesTo = newRelatesToList;
    } else if (resourceType === "Group" || resourceType === 'CodeSystem' ||
        resourceType === "List" || resourceType === 'ActivityDefinition' ||
        resourceType === 'PlanDefinition' || resourceType === 'ValueSet' || resourceType === "Measure"
    ) {
        let citeAsExtension = {
            "url": "http://hl7.org/fhir/uv/ebm/StructureDefinition/cite-as",
            "valueMarkdown": citationSummary
        };
        let citeAsFound = false;
        let newCiteAsExtensionList = [];
        if (Array.isArray(fhirJson.extension) && fhirJson.extension.length > 0) {
            newCiteAsExtensionList = fhirJson.extension.map((extension) => {
                if (extension.url === 'http://hl7.org/fhir/uv/ebm/StructureDefinition/cite-as' &&
                    extension.valueMarkdown) {
                    citeAsFound = true;
                    return citeAsExtension;
                } else {
                    return extension;
                }
            })
        }
        if (citeAsFound === false) {
            newCiteAsExtensionList.push(citeAsExtension);
        }
        fhirJson.extension = newCiteAsExtensionList;
        if (Array.isArray(fhirJson.relatedArtifact) && fhirJson.relatedArtifact.length) {
            fhirJson.relatedArtifact = fhirJson.relatedArtifact.filter(item => item.type !== "cite-as");
        }
        if (Array.isArray(fhirJson.extension) && fhirJson.extension.length) {
            let filteredExtension = fhirJson.extension.filter(ext => !(ext.url === "http://hl7.org/fhir/StructureDefinition/artifact-relatedArtifact" &&
                ext.valueRelatedArtifact?.type === "cite-as"));
            fhirJson.extension = filteredExtension;
            if (resourceType === "Group") {
                fhirJson.extension = fhirJson.extension.map(ext => {
                    if (ext.url === "http://hl7.org/fhir/StructureDefinition/artifact-relatedArtifact") {
                        ext.url = "http://hl7.org/fhir/uv/ebm/StructureDefinition/relates-to";
                        ext.extension = [{
                            "url": "type",
                            "valueCode": ext.valueRelatedArtifact.type
                        }];
                        if (ext.valueRelatedArtifact.resourceReference) {
                            ext.extension.push({ "url": "targetReference", "valueReference": ext.valueRelatedArtifact.resourceReference });
                        } else if (ext.valueRelatedArtifact.resource) {
                            ext.extension.push({ "url": "targetCanonical", "valueCanonical": ext.valueRelatedArtifact.resource });
                        } else if (ext.valueRelatedArtifact.document) {
                            let attachment = ext.valueRelatedArtifact.document;
                            if (!attachment.title && (ext.valueRelatedArtifact.display || ext.valueRelatedArtifact.label ||
                                ext.valueRelatedArtifact.classifier)) {
                                attachment.title = ext.valueRelatedArtifact.display || ext.valueRelatedArtifact.label ||
                                    JSON.stringify(ext.valueRelatedArtifact.classifier)
                            }
                            ext.extension.push({ "url": "targetAttachment", "valueAttachment": attachment });
                        } else if (ext.valueRelatedArtifact.citation) {
                            ext.extension.push({ "url": "targetMarkdown", "valueMarkdown": ext.valueRelatedArtifact.citation });
                        }
                        delete ext.valueRelatedArtifact;
                    }
                    return ext;
                })
            }
        }
    }
};

export { addCitationSummaryToFhirJson, generateCitationSummaryFromFhirJson };